module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "index": "1",
      "showbar": "true"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_game_dialog),
      expression: "show_game_dialog"
    }],
    staticClass: "dialog_masker",
    staticStyle: {
      "height": "100%",
      "z-index": "214748364778!important"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.show_game_dialog = false;
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "middle game_dailog",
    staticStyle: {
      "width": "6.5rem",
      "height": "10.5rem",
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "close_game_dialog",
    on: {
      "click": function($event) {
        _vm.show_game_dialog = false
      }
    }
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('img', {
    staticStyle: {
      "width": "6.5rem",
      "height": "10.5rem",
      "position": "absolute",
      "left": "0",
      "top": "0",
      "border-radius": "5px"
    },
    attrs: {
      "src": _vm.imglist[21]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    staticStyle: {
      "width": "6.5rem",
      "height": "10.5rem",
      "position": "absolute",
      "left": "0",
      "top": "0",
      "border-radius": "5px"
    },
    attrs: {
      "src": _vm.imglist[22]
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "banner banner1"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.banner_title'))
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title banner_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.banner_text'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center button_banner",
    staticStyle: {
      "position": "absolute",
      "top": "48%",
      "width": "100%"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/product"
    }
  }, [_c('a', {
    staticClass: "button_default",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.download'))
    }
  })]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#fff",
      "margin-top": "30%"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.vrviu'))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "guaid_arrow"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.title1'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.$i18n.locale == 'ch') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticStyle: {
      "width": "5.18rem",
      "height": "9.45rem",
      "margin": "0.4rem auto 0 auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[10]),
      expression: "imglist[10]"
    }],
    staticStyle: {
      "width": "5.18rem",
      "height": "9.45rem",
      "margin": "0.4rem auto 0 auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "background": "#f4f9ff",
      "margin-top": "0.7rem"
    }
  }, [_c('ul', {
    staticClass: "bar_list clearfix"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.item_title1'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon bar_icon1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.item_title2'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item bar_item2"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon bar_icon2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.item_title3'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item bar_item1"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/technology"
    }
  }, [_c('span', {
    staticClass: "bar_icon bar_icon3"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_tex",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.item_title4'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bar_item bar_item2 bar_item1"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.title2'))
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center support_model"
  }, [_c('span', {
    class: {
      "active_tab": _vm.showTab == 1
    },
    staticStyle: {
      "margin-right": "30px"
    },
    on: {
      "mouseover": function($event) {
        _vm.showTab = 1
      }
    }
  }, [_vm._v("VR")]), _c('span', {
    class: {
      "active_tab": _vm.showTab == 2
    },
    on: {
      "mouseover": function($event) {
        _vm.showTab = 2
      }
    }
  }, [_vm._v("2D")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "pictures"
  }, [(_vm.showTab == 1) ? _c('ul', [_c('li', {
    staticClass: "pic_content"
  }, [_c('div', {
    staticClass: "pic_item"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution1"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[2]),
      expression: "imglist[2]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.pic_text1'))
    }
  })])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "pic_content pic_content1 clearfix"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "pic_item"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[3]),
      expression: "imglist[3]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.pic_text2'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "pic_item pic_item2"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[4]),
      expression: "imglist[4]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.pic_text3'))
    }
  })])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "pic_content pic_content1 clearfix"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "pic_item"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[5]),
      expression: "imglist[5]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.pic_text4'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "pic_item pic_item2"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[6]),
      expression: "imglist[6]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.pic_text5'))
    }
  })])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.showTab == 2) ? _c('ul', [_c('li', {
    staticClass: "pic_content"
  }, [_c('div', {
    staticClass: "pic_item"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution2"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[11]),
      expression: "imglist[11]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.text4'))
    }
  })])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "pic_content"
  }, [_c('div', {
    staticClass: "pic_item"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution2"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[12]),
      expression: "imglist[12]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.text5'))
    }
  })])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "pic_content"
  }, [_c('div', {
    staticClass: "pic_item"
  }, [_c('router-link', {
    attrs: {
      "to": "/solution2"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[13]),
      expression: "imglist[13]"
    }],
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.text6'))
    }
  })])], 1)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content_item",
    staticStyle: {
      "background": "#f4f9ff",
      "height": "5.5rem",
      "position": "relative"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.title3'))
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.4rem",
      "margin": "0.4rem 0.32rem 0 0.32rem"
    }
  }, [_c('my-video', {
    ref: "video",
    attrs: {
      "sources": _vm.video.sources,
      "options": _vm.video.options
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_play_btn),
      expression: "show_play_btn"
    }],
    staticClass: "playBtn",
    on: {
      "click": function($event) {
        _vm.play_video()
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content_item",
    staticStyle: {
      "margin-bottom": "-0.36rem"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.try_download'))
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[7]),
      expression: "imglist[7]"
    }],
    staticStyle: {
      "width": "4.05rem",
      "height": "3.69rem",
      "margin": "0.4rem auto 0.1rem auto"
    },
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('router-link', {
    attrs: {
      "to": "/software"
    }
  }, [_c('a', {
    staticClass: "button_default button_default2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.try_download_btn'))
    }
  })])], 1), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    staticStyle: {
      "margin-top": "1.4rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.friends'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center friendsList clearfix"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[14]),
      expression: "imglist[14]"
    }],
    staticStyle: {
      "width": "2.7rem",
      "height": "1rem"
    },
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[15]),
      expression: "imglist[15]"
    }],
    staticStyle: {
      "width": "2.7rem",
      "height": "1rem"
    },
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[16]),
      expression: "imglist[16]"
    }],
    staticStyle: {
      "width": "2.7rem",
      "height": "1rem"
    },
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[17]),
      expression: "imglist[17]"
    }],
    staticStyle: {
      "width": "2.7rem",
      "height": "1rem"
    },
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[18]),
      expression: "imglist[18]"
    }],
    staticStyle: {
      "width": "2.7rem",
      "height": "1rem"
    },
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[19]),
      expression: "imglist[19]"
    }],
    staticStyle: {
      "width": "2.7rem",
      "height": "1rem"
    },
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[20]),
      expression: "imglist[20]"
    }],
    staticStyle: {
      "width": "2.7rem",
      "height": "1rem"
    },
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[8]),
      expression: "imglist[8]",
      arg: "background-image"
    }],
    staticClass: "content_bg"
  }, [_c('div', {
    staticClass: "content_footer"
  }, [_c('h3', {
    staticClass: "content_item_title white",
    staticStyle: {
      "magin-bottom": "0.4rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.try_free'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "content_item_text content_item_text1 white",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.try_free_text'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "content_item_text white",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.try_free_text2'))
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "button_default",
    staticStyle: {
      "margin-top": "0.7rem"
    },
    attrs: {
      "to": "/product"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.index.try_free_btn'))
    }
  })], 1)])])])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d30bb0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 91
// module chunks = 0